export default __webpack_public_path__ + "static/media/kelechi.647323e4.jpg";